module.exports = __webpack_public_path__ + "img/landscape-1.7a96d75b.jpg";